import { render, staticRenderFns } from "./HyphenSignature.vue?vue&type=template&id=549fe3c7&scoped=true"
import script from "./HyphenSignature.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenSignature.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenSignature.vue?vue&type=style&index=0&id=549fe3c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549fe3c7",
  null
  
)

export default component.exports